import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { PriceResponse } from 'src/app/models/price-response.model'

@Injectable({
  providedIn: 'root',
})
export class PriceService {
  public static readonly priceEndpoint = '/price'

  constructor(private readonly http: HttpClient) {}

  getDailyPrice(fundId: string): Observable<PriceResponse> {
    return this.http.get<PriceResponse>(
      `vmf/api/${fundId}`.concat(PriceService.priceEndpoint),
    )
  }
}
